/****************************************************
* Module Name:  AddPricePlanModal.js
* Project:      Pansuriya Impex Sales & Manufacturing
* Owner:        info@pansuriyaimpex.com
*
* Copyright (c) Pansuriya Impex
* All rights reserved.
****************************************************/
import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Modal from "react-bootstrap/Modal";
import Constants from "../../../utility/constants";
import "../../../style/modalstyle.css";
import logo from '../../../images/pansuriya.jpg'
import ShapeProxy from "../../../utility/proxy/manager/shapeProxy";
import ColorProxy from "../../../utility/proxy/manager/colorProxy";
import ClarityProxy from "../../../utility/proxy/manager/clarityProxy";
import CutProxy from "../../../utility/proxy/manager/cutProxy";
import PolProxy from "../../../utility/proxy/manager/polProxy";
import SymProxy from "../../../utility/proxy/manager/symProxy";
import FloProxy from "../../../utility/proxy/manager/floProxy";
import Select from "react-select";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import LabProxy from "../../../utility/proxy/manager/labProxy";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const AddPricePlanModal = ({
    show,
    loader,
    handleSave,
    handleClose,
    tenderstoneid,
    fromTender,
    lotCode,
    totalLotPieces,
    totalLotCarats,
    stoneSize,
    stonePieces,
}) => {

    const [disableAdd, setDisableAdd] = useState(true);
    const [showAllShape, setShowAllShape] = useState(false);

    // Set Values
    const [kapanid, setKapanId] = useState(null);
    const [packetid, setPacketId] = useState(null);
    const [shape, setShape] = useState("");
    const [size, setSize] = useState("");
    const [color, setColor] = useState([]);
    const [clarity, setClarity] = useState("");
    const [cut, setCut] = useState("");
    const [pol, setPol] = useState("");
    const [sym, setSym] = useState("");
    const [flo, setFlo] = useState("");
    const [planId, setPlanId] = useState("");
    const [stonetype, setStonetype] = useState("");
    const [lab, setLab] = useState("");
    const [isCertified, setIsCertified] = useState(true);
    const [colorWhite, setColorWhite] = useState(true);
    const [fancyColorOne, setFancyColorOne] = useState("");
    const [fancyColorTwo, setFancyColorTwo] = useState("");
    const [fromIntensity, setFromIntensity] = useState("");
    const [toIntensity, setToIntensity] = useState("");
    const [overtone, setOvertone] = useState("");

    const [threeEX, setThreeEX] = useState(false);
    const [threeEXCut, setThreeEXCut] = useState(false);
    const [threeVGPlus, setThreeVGPlus] = useState(false);

    // Set Options
    const [shapeOptions, setShapeOptions] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [clarityOptions, setClarityOptions] = useState([]);
    const [cutOptions, setCutOptions] = useState([]);
    const [polOptions, setPolOptions] = useState([]);
    const [symOptions, setSymOptions] = useState([]);
    const [floOptions, setFloOptions] = useState([]);
    const [stonetypeOptions, setStonetypeOptions] = useState([]);
    const [labOptions, setLabOptions] = useState([]);
    const [planOptions, setPlanOptions] = useState([]);
    const [noOfStones, setNoOfStones] = useState(1);
    const [data, setData] = useState([]);

    const fancyColorOption = [
        { value: "Yellow", label: "Yellow" },
        { value: "Pink", label: "Pink" },
        { value: "Blue", label: "Blue" },
        { value: "Red", label: "Red" },
        { value: "Green", label: "Green" },
        { value: "Purple", label: "Purple" },
        { value: "Orange", label: "Orange" },
        { value: "Gray", label: "Gray" },
        { value: "Black", label: "Black" },
        { value: "Brown", label: "Brown" },
        { value: "Other", label: "Other" },
        { value: "White", label: "White" }
    ];

    const overtoneOption = [
        { value: "Yellow", label: "Yellow" },
        { value: "Yellowish", label: "Yellowish" },
        { value: "Pink", label: "Pink" },
        { value: "Pinkish", label: "Pinkish" },
        { value: "Blue", label: "Blue" },
        { value: "Bluish", label: "Bluish" },
        { value: "Red", label: "Red" },
        { value: "Redish", label: "Redish" },
        { value: "Green", label: "Green" },
        { value: "Greenish", label: "Greenish" },
        { value: "Purple", label: "Purple" },
        { value: "Purplish", label: "Purplish" },
        { value: "Orange", label: "Orange" },
        { value: "Orangey", label: "Orangey" },
        { value: "Violet", label: "Violet" },
        { value: "Gray", label: "Gray" },
        { value: "Grayish", label: "Grayish" },
        { value: "Brown", label: "Brown" },
        { value: "Brownish", label: "Brownish" },
        { value: "Other", label: "Other" },
        { value: "Brown-Greenish", label: "Brown-Greenish" }
    ];

    const intensityOption = [
        { value: "Faint", label: "Faint" },
        { value: "Very Light", label: "Very Light" },
        { value: "Light", label: "Light" },
        { value: "Fancy Light", label: "Fancy Light" },
        { value: "Fancy", label: "Fancy" },
        { value: "Fancy Dark", label: "Fancy Dark" },
        { value: "Fancy Intense", label: "Fancy Intense" },
        { value: "Fancy Vivid", label: "Fancy Vivid" },
        { value: "Fancy Deep", label: "Fancy Deep" },
        { value: "Fancy Brown", label: "Fancy Brown" }
    ];

    useEffect(() => {
        getAllShapeData();
        getAllColorData();
        getAllClarityData();
        getAllCutData();
        getAllPolData();
        getAllSymData();
        getAllFloData();
        getAllStoneTypeData();
        getAllLabData();
        setAllPlanOptions();
    }, []);

    const getAllLabData = () => {
        LabProxy.GetAllLabMini((response) => {
            setAllLabData(response);
        });
    };

    const getAllShapeData = () => {
        ShapeProxy.GetAllShapeMini((response) => {
            setAllShapeData(response);
        });
    };

    const getAllColorData = () => {
        ColorProxy.GetAllColorMini((response) => {
            setAllColorData(response);
        });
    };

    const getAllClarityData = () => {
        ClarityProxy.GetAllClarityMini((response) => {
            setAllClarityData(response);
        });
    };

    const getAllCutData = () => {
        CutProxy.GetAllCutMini((response) => {
            setAllCutData(response);
        });
    };

    const getAllPolData = () => {
        PolProxy.GetAllPolMini((response) => {
            setAllPolData(response);
        });
    };

    const getAllSymData = () => {
        SymProxy.GetAllSymMini((response) => {
            setAllSymData(response);
        });
    };

    const getAllFloData = () => {
        FloProxy.GetAllFloMini((response) => {
            setAllFloData(response);
        });
    };

    const getAllStoneTypeData = () => {
        setAllStoneTypeData();
    };

    const setAllPlanOptions = () => {
        let optionsArray = [];
        for (let i = 1; i <= 50; i++) {
            let option = {
                value: i,
                label: i,
            };
            optionsArray.push(option);
        }
        setPlanOptions(optionsArray);
    }

    const setAllLabData = (response) => {
        let optionsArray = response
            .filter((data) => data.name !== "HRD") // We are excluding HRD from the LAB dropdown
            .map((data) => {

                let val = {
                    value: data.id,
                    label: data.name,
                    selected: data.name === "GIA",
                }

                if (data.name === "GIA")
                    setLab(val);
                return val;
            });
        setLabOptions(optionsArray);
    };

    const setAllShapeData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.name,
                image: data.image,
                selected: false
            };
            optionsArray.push(option);
            return true;
        });
        setShapeOptions(optionsArray);
    };

    const setAllColorData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.name,
                selected: false
            };
            optionsArray.push(option);
            return true;
        });
        setColorOptions(optionsArray);
    };

    const setAllClarityData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.name,
                selected: false
            };
            optionsArray.push(option);
            return true;
        });
        setClarityOptions(optionsArray);
    };

    const setAllCutData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.name,
                selected: false
            };
            optionsArray.push(option);
            return true;
        });
        setCutOptions(optionsArray);
    };

    const setAllPolData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.name,
                selected: false
            };
            optionsArray.push(option);
            return true;
        });
        setPolOptions(optionsArray);
    };

    const setAllSymData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.name,
                selected: false
            };
            optionsArray.push(option);
            return true;
        });
        setSymOptions(optionsArray);
    };

    const setAllFloData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.name,
                selected: false
            };
            optionsArray.push(option);
            return true;
        });
        setFloOptions(optionsArray);
    };

    const setAllStoneTypeData = () => {
        let optionsArray = [];
        optionsArray.push({ value: "N", label: "Natural Diamonds", selected: true });
        optionsArray.push({ value: "L", label: "Lab Grown Diamonds", selected: false });
        setStonetypeOptions(optionsArray);

        setStonetype(optionsArray[0]);
    };

    const handleCheckBox = (event) => {
        setIsCertified(event.target.checked);
    };

    useEffect(() => {
        if ((tenderstoneid || (kapanid && packetid)) && shape && size &&
            (colorWhite ? color.length > 0 : fromIntensity && toIntensity &&
                overtone && fancyColorOne && fancyColorTwo) && cut && pol && sym && flo &&
            clarity && stonetype && planId && lab) {
            setDisableAdd(false);
        } else {
            setDisableAdd(true);
        }
    }, [kapanid, packetid, shape, size, cut, pol, sym, flo, clarity,
        stonetype, planId, lab, color, fromIntensity, toIntensity,
        overtone, fancyColorOne, fancyColorTwo, colorWhite]);

    const handleSubmit = () => {
        if (data.length > 0) {
            const cleanedData = data.map(item => {
                const cleanedItem = {};
                for (const key in item) {
                    // Check if the value is an object with the structure we want to clean
                    if (typeof item[key] === 'object' && item[key] !== null) {
                        cleanedItem[key] = item[key].value; // Only keep the value field
                    } else {
                        cleanedItem[key] = item[key]; // Keep the other fields as they are
                    }
                }
                return cleanedItem;
            });
            if (handleSave) {
                handleSave(cleanedData);
            }
        }
    };

    const addPlan = () => {
        let iData = [...data];
        if (colorWhite) {
            color.forEach(iColor => {
                let row = {
                    kapanid: kapanid,
                    packetid: packetid,
                    createdby: Constants.loggedInUser.id,
                    shape: shape,
                    colortype: colorWhite ? "WHITE" : "FANCY",
                    color: iColor,
                    fancycolor1: undefined,
                    fancycolor2: undefined,
                    overtone: undefined,
                    fromintensity: undefined,
                    tointensity: undefined,
                    cut: cut,
                    pol: pol,
                    size: size,
                    sym: sym,
                    clarity: clarity,
                    flo: flo,
                    stonetype: stonetype,
                    iscertified: isCertified,
                    planid: planId,
                    lab: lab,
                    noofstones: noOfStones,
                    tenderstoneid: tenderstoneid,
                }
                iData.push(row);
            })
        } else {
            let row = {
                kapanid: kapanid,
                packetid: packetid,
                createdby: Constants.loggedInUser.id,
                shape: shape,
                colortype: colorWhite ? "WHITE" : "FANCY",
                color: undefined,
                fancycolor1: fancyColorOne,
                fancycolor2: fancyColorTwo,
                overtone: overtone,
                fromintensity: fromIntensity,
                tointensity: toIntensity,
                cut: cut,
                pol: pol,
                size: size,
                sym: sym,
                clarity: clarity,
                flo: flo,
                stonetype: stonetype,
                iscertified: isCertified,
                planid: planId,
                lab: lab,
                noofstones: noOfStones,
                tenderstoneid: tenderstoneid,
            }
            iData.push(row);
        }

        setData(iData);
    }

    const deletePlan = (index) => {
        let newData = data.filter((_, idx) => index !== idx);
        setData(newData);
    }

    const resetPlan = () => {
        setKapanId(null);
        setPacketId(null);
        setShape("");
        setSize("");
        setColor([]);
        setClarity("");
        setCut("");
        setPol("");
        setSym("");
        setFlo("");
        setPlanId("");
        setStonetype("");
        setLab("");
        setIsCertified(true);
        setThreeVGPlus(false);
        setThreeEXCut(false);
        setThreeEX(false);
        setNoOfStones(1);
        setShapeOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setColorOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setClarityOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setCutOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setPolOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setSymOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setFloOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setStonetypeOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setLabOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setPlanOptions(prevOptions => prevOptions.map(option => ({ ...option, selected: false })));
        setFancyColorOne("");
        setFancyColorTwo("");
        setFromIntensity("");
        setToIntensity("");
        setOvertone("");
    }

    const handleShapeSelect = (shape, idx) => {
        let tShapeOptions = shapeOptions.map((iShape, index) => {
            if (index === idx) {
                if (iShape.selected) {
                    setShape(undefined);
                } else {
                    setShape(shape);
                }
                return { ...iShape, selected: !iShape.selected };
            } else {
                return { ...iShape, selected: false };
            }
        });
        setShapeOptions(tShapeOptions);
    }

    const showShapes = () => {
        let optionsToUse = showAllShape ? shapeOptions : shapeOptions.slice(0, 18);
        return optionsToUse.map((shape, idx) => (
            <button
                onClick={() => handleShapeSelect(shape, idx)}
                style={{ borderRadius: 4, margin: 2, minWidth: '70px', border: 1, borderStyle: 'solid', borderColor: '#ececec', maxWidth: '70px', height: '70px', alignItems: 'center', backgroundColor: shape.selected ? "#b8bcc4" : '#fff', color: '#000' }} >
                <div style={{ transform: "translateY(5px)" }}>
                    <div>
                        <img className={shape.selected ? "filter-white" : ''} src={`data:image/svg+xml;base64,${shape.image}`} width={30} height={30} alt="" style={{ border: 1, borderColor: "#fff" }} />
                    </div>
                    <div style={{ height: 50 }}>
                        <p style={{ fontSize: 11, fontWeight: 'bold' }}>{shape.label}</p>
                    </div>
                </div>
            </button>
        ));
    }

    const handleColorSelect = (idx) => {
        let tColorOptions = colorOptions.map((iColor, index) => {
            if (index === idx) {
                let tcolor = [...color];
                if (iColor.selected) {
                    tcolor = tcolor.filter(tempColor => tempColor.value !== iColor.value);
                } else {
                    tcolor.push(iColor);
                }
                setColor(tcolor);
                return { ...iColor, selected: !iColor.selected };
            }
            return { ...iColor };
        });
        setColorOptions(tColorOptions);
    }

    const handleClaritySelect = (clarity, idx) => {
        let tClarityOptions = clarityOptions.map((iClarity, index) => {
            if (index === idx) {
                if (iClarity.selected) {
                    setClarity(undefined);
                } else {
                    setClarity(clarity);
                }
                return { ...iClarity, selected: !iClarity.selected };
            } else {
                return { ...iClarity, selected: false };
            }
        });
        setClarityOptions(tClarityOptions);
    }

    const handleCutSelect = (cut, idx) => {
        let tCutOptions = cutOptions.map((iCut, index) => {
            if (index === idx) {
                if (iCut.selected) {
                    setCut(undefined);
                } else {
                    setCut(cut);
                }
                return { ...iCut, selected: !iCut.selected };
            } else {
                return { ...iCut, selected: false };
            }
        });
        setCutOptions(tCutOptions);
    }

    const handlePolSelect = (pol, idx) => {
        let tPolOptions = polOptions.map((iPol, index) => {
            if (index === idx) {
                if (iPol.selected) {
                    setPol(undefined);
                } else {
                    setPol(pol);
                }
                return { ...iPol, selected: !iPol.selected };
            } else {
                return { ...iPol, selected: false };
            }
        });
        setPolOptions(tPolOptions);
    }

    const handleSymSelect = (sym, idx) => {
        let tSymOptions = symOptions.map((iSym, index) => {
            if (index === idx) {
                if (iSym.selected) {
                    setSym(undefined);
                } else {
                    setSym(sym);
                }
                return { ...iSym, selected: !iSym.selected };
            } else {
                return { ...iSym, selected: false };
            }
        });
        setSymOptions(tSymOptions);
    }

    const handleFloSelect = (flo, idx) => {
        let tFloOptions = floOptions.map((iFlo, index) => {
            if (index === idx) {
                if (iFlo.selected) {
                    setFlo(undefined);
                } else {
                    setFlo(flo);
                }
                return { ...iFlo, selected: !iFlo.selected };
            } else {
                return { ...iFlo, selected: false };
            }
        });
        setFloOptions(tFloOptions);
    }

    const handleStonetypeSelect = (stonetype, idx) => {
        let tStonetypeOptions = stonetypeOptions.map((iStonetype, index) => {
            if (index === idx) {
                if (iStonetype.selected) {
                    setStonetype(undefined);
                } else {
                    setStonetype(stonetype);
                }
                return { ...iStonetype, selected: !iStonetype.selected };
            } else {
                return { ...iStonetype, selected: false };
            }
        });
        setStonetypeOptions(tStonetypeOptions);
    }

    const handleLabSelect = (lab, idx) => {
        let tLabOptions = labOptions.map((iLab, index) => {
            if (index === idx) {
                if (iLab.selected) {
                    setLab(undefined);
                } else {
                    setLab(lab);
                }
                return { ...iLab, selected: !iLab.selected };
            } else {
                return { ...iLab, selected: false };
            }
        });
        setLabOptions(tLabOptions);
    }

    const handle3EX = () => {
        let selected = threeEX;
        setThreeEX(!selected);
        setThreeEXCut(false);
        setThreeVGPlus(false);
        let tCutOptions = [];
        let tPolOptions = [];
        let tSymOptions = [];
        if (!selected) {
            // Cut
            tCutOptions = cutOptions.map(iCut => {
                if (iCut.label === "EX") {
                    setCut(iCut);
                    return { ...iCut, selected: true }
                } else {
                    return { ...iCut, selected: false }
                }
            });

            // Pol
            tPolOptions = polOptions.map(iPol => {
                if (iPol.label === "EX") {
                    setPol(iPol);
                    return { ...iPol, selected: true }
                } else {
                    return { ...iPol, selected: false }
                }
            })

            // Sym
            tSymOptions = symOptions.map(iSym => {
                if (iSym.label === "EX") {
                    setSym(iSym);
                    return { ...iSym, selected: true }
                } else {
                    return { ...iSym, selected: false }
                }
            })
        } else {
            // Cut
            tCutOptions = cutOptions.map(iCut => ({ ...iCut, selected: false }));
            setCut(undefined);

            // Pol
            tPolOptions = polOptions.map(iPol => ({ ...iPol, selected: false }));
            setPol(undefined);

            // Sym
            tSymOptions = symOptions.map(iSym => ({ ...iSym, selected: false }));
            setSym(undefined);
        }
        setCutOptions(tCutOptions);
        setPolOptions(tPolOptions);
        setSymOptions(tSymOptions);
    }

    const handle3EXCut = () => {
        let selected = threeEXCut;
        setThreeEX(false);
        setThreeEXCut(!selected);
        setThreeVGPlus(false);
        let tCutOptions = [];
        let tPolOptions = [];
        let tSymOptions = [];
        if (!selected) {
            // Cut
            tCutOptions = cutOptions.map(iCut => {
                if (iCut.label === "EX") {
                    setCut(iCut);
                    return { ...iCut, selected: true }
                } else {
                    return { ...iCut, selected: false }
                }
            });

            // Pol
            tPolOptions = polOptions.map(iPol => {
                if (iPol.label === "VG") {
                    setPol(iPol);
                    return { ...iPol, selected: true }
                } else {
                    return { ...iPol, selected: false }
                }
            })

            // Sym
            tSymOptions = symOptions.map(iSym => {
                if (iSym.label === "VG") {
                    setSym(iSym);
                    return { ...iSym, selected: true }
                } else {
                    return { ...iSym, selected: false }
                }
            })
        } else {
            // Cut
            tCutOptions = cutOptions.map(iCut => ({ ...iCut, selected: false }));
            setCut(undefined);

            // Pol
            tPolOptions = polOptions.map(iPol => ({ ...iPol, selected: false }));
            setPol(undefined);

            // Sym
            tSymOptions = symOptions.map(iSym => ({ ...iSym, selected: false }));
            setSym(undefined);
        }
        setCutOptions(tCutOptions);
        setPolOptions(tPolOptions);
        setSymOptions(tSymOptions);
    }

    const handle3VG = () => {
        let selected = threeVGPlus;
        setThreeEX(false);
        setThreeEXCut(false);
        setThreeVGPlus(!selected);
        let tCutOptions = [];
        let tPolOptions = [];
        let tSymOptions = [];
        if (!selected) {
            // Cut
            tCutOptions = cutOptions.map(iCut => {
                if (iCut.label === "VG") {
                    setCut(iCut);
                    return { ...iCut, selected: true }
                } else {
                    return { ...iCut, selected: false }
                }
            });

            // Pol
            tPolOptions = polOptions.map(iPol => {
                if (iPol.label === "VG") {
                    setPol(iPol);
                    return { ...iPol, selected: true }
                } else {
                    return { ...iPol, selected: false }
                }
            })

            // Sym
            tSymOptions = symOptions.map(iSym => {
                if (iSym.label === "VG") {
                    setSym(iSym);
                    return { ...iSym, selected: true }
                } else {
                    return { ...iSym, selected: false }
                }
            })
        } else {
            // Cut
            tCutOptions = cutOptions.map(iCut => ({ ...iCut, selected: false }));
            setCut(undefined);

            // Pol
            tPolOptions = polOptions.map(iPol => ({ ...iPol, selected: false }));
            setPol(undefined);

            // Sym
            tSymOptions = symOptions.map(iSym => ({ ...iSym, selected: false }));
            setSym(undefined);
        }
        setCutOptions(tCutOptions);
        setPolOptions(tPolOptions);
        setSymOptions(tSymOptions);
    }

    return (
        <div>
            <Modal
                show={show}
                onHide={handleClose}
                enforceFocus={false}
                backdrop="static"
                keyboard={true}
                dialogClassName="max-modalSize"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                                src={logo}
                                height="40pt"
                                width="40pt"
                                alt={Constants.COMPANY_SITE}
                            />
                            <Box sx={{ ml: 2 }}>
                                <Typography variant="h5">Add Price Plan</Typography>
                                {fromTender &&
                                    (<Typography variant="body2">
                                        <strong>LOT CODE:</strong> {lotCode} &nbsp;&nbsp; | &nbsp;&nbsp;
                                        <strong>TOTAL LOT PIECES:</strong> {totalLotPieces} &nbsp;&nbsp; | &nbsp;&nbsp;
                                        <strong>TOTAL LOT CARATS:</strong> {totalLotCarats} &nbsp;&nbsp; | &nbsp;&nbsp;
                                        <strong>TENDER STONE ID:</strong> {tenderstoneid} &nbsp;&nbsp; | &nbsp;&nbsp;
                                        <strong>TENDER STONE SIZE:</strong> {stoneSize} &nbsp;&nbsp; | &nbsp;&nbsp;
                                        <strong>TENDER STONE PIECES:</strong> {stonePieces ? stonePieces : 0}
                                    </Typography>)
                                }
                            </Box>
                        </Box>
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    <Box sx={{
                        paddingTop: "10px",
                        "& .MuiOutlinedInput-input": {
                            padding: "9px !important"
                        },
                        "& .MuiInputLabel-root": {
                            top: "-7px !important"
                        }
                    }}>
                        <Box sx={{
                            display: "flex",
                            paddingBottom: "20px",
                            borderBottom: "1px solid #ececec",
                            "& .MuiFormControlLabel-root": {
                                margin: 0,
                            },
                        }}>

                            {!fromTender ? (
                                <Box sx={{ display: "flex", width: "26%" }}>
                                    {/* ---------- Kapan ID ---------- */}
                                    <Box sx={{ width: "48%", paddingRight: "25px", borderRight: "1px solid #ececec" }}>
                                        <Typography sx={{ marginBottom: "10px" }}>Kapan Id
                                            <sup style={{ color: "red", marginLeft: "4px" }}>*</sup>
                                        </Typography>
                                        <TextField
                                            sx={{ margin: 0 }}
                                            margin="normal"
                                            placeholder="Kapan Id"
                                            value={kapanid}
                                            onChange={(e) => {
                                                if (/^[1-9]\d*$/.test(e.target.value) || e.target.value === "") {
                                                    setKapanId(e.target.value);
                                                }
                                            }}
                                        />
                                    </Box>

                                    {/* ---------- Packet ID ---------- */}
                                    <Box sx={{ width: "52%", px: "25px", borderRight: "1px solid #ececec" }}>
                                        <Typography sx={{ marginBottom: "10px" }}>Packet Id
                                            <sup style={{ color: "red", marginLeft: "4px" }}>*</sup>
                                        </Typography>
                                        <TextField
                                            sx={{ margin: 0 }}
                                            margin="normal"
                                            placeholder="Packet Id"
                                            value={packetid}
                                            onChange={(e) => setPacketId(e.target.value)}
                                        />
                                    </Box>
                                </Box>
                            ) : (
                                <Box sx={{ display: "flex", width: "26%", borderRight: "1px solid #ececec" }}>
                                    {/* ---------- Tender Stone ID ---------- */}
                                    <Box sx={{ width: "100%", paddingRight: "25px" }}>
                                        <Typography sx={{ marginBottom: "10px" }}>Tender Stone Id<sup style={{ color: "red", marginLeft: "4px" }}>*</sup>
                                        </Typography>
                                        <TextField
                                            sx={{ margin: 0, width: "100%" }}
                                            margin="normal"
                                            value={tenderstoneid}
                                            disabled={true}
                                        />
                                    </Box>
                                </Box>
                            )}

                            {/* ---------- Plan ---------- */}
                            <Box sx={{ width: "12%", px: "25px", borderRight: "1px solid #ececec" }}>
                                <Typography sx={{ marginBottom: "10px" }}>Plan
                                    <sup style={{ color: "red", marginLeft: "4px" }}>*</sup>
                                </Typography>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        ...Constants.Styles,
                                        control: (base) => ({
                                            ...base,
                                            width: '7rem', // Adjust the width as needed
                                            minHeight: "43px"
                                        }),
                                    }}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.value}
                                    options={planOptions}
                                    value={planId}
                                    onChange={(e) => setPlanId(e)}
                                />
                            </Box>

                            {/* ------------ Size ---------- */}
                            <Box sx={{ width: "12%", px: "25px", borderRight: "1px solid #ececec" }}>
                                <Typography sx={{ marginBottom: "10px" }}>Size<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                <TextField
                                    sx={{ margin: 0 }}
                                    margin="normal"
                                    placeholder="Size"
                                    value={size}
                                    type="number"
                                    inputProps={{ step: "0.01", min: "0" }}
                                    onChange={(e) => {
                                        // Allow only positive integers or floats (like 1, 2.5, etc.)
                                        if (e.target.value >= 0 || e.target.value === '') {
                                            setSize(e.target.value);
                                        }
                                    }}
                                />
                            </Box>

                            {/* ------------ Stonetype ---------- */}
                            <Box sx={{ width: "25%", px: "25px", borderRight: "1px solid #ececec" }}>
                                <Typography sx={{ marginBottom: "10px" }}>Stonetype<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px 10px" }}>
                                    {stonetypeOptions.map((stonetype, idx) => (
                                        <button
                                            onClick={() => handleStonetypeSelect(stonetype, idx)}
                                            style={{ borderRadius: 7, margin: 2, minWidth: '40px', height: '40px', alignItems: 'center', backgroundColor: stonetype.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                            <div>
                                                <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{stonetype.label}</p>
                                            </div>
                                        </button>
                                    ))}
                                </Box>
                            </Box>

                            {/* ------------ Lab ---------- */}
                            <Box sx={{ width: "13%", px: "25px", borderRight: "1px solid #ececec" }}>
                                <Typography sx={{ marginBottom: "10px" }}>Lab<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px 10px" }}>
                                    {labOptions.map((lab, idx) => (
                                        <button
                                            onClick={() => handleLabSelect(lab, idx)}
                                            style={{ borderRadius: 7, margin: 2, minWidth: '40px', height: '40px', alignItems: 'center', backgroundColor: lab.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                            <div>
                                                <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{lab.label}</p>
                                            </div>
                                        </button>
                                    ))}
                                </Box>
                            </Box>

                            {/* ------------ isCertified ---------- */}
                            <Box display={"flex"} alignItems={"center"} px={"20px"}>
                                <Typography sx={{ width: "70%", margin: "1px 0 0 0", paddingRight: "15px" }}>Certified</Typography>
                                <Box sx={{ display: "flex", alignItems: "center" }}>

                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    onChange={handleCheckBox}
                                                    size="small"
                                                    checked={isCertified}
                                                />
                                            }
                                        />
                                    </FormGroup>
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{ display: "flex", padding: "10px 0", borderBottom: "1px solid #ececec", }}>

                            {/* ---------- Shape ---------- */}
                            <Box sx={{ width: "35%", paddingRight: "20px", borderRight: "1px solid #ececec" }}>
                                <Typography sx={{ paddingBottom: "10px" }}>Shape<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                <Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: "8px 6px" }}>
                                    {showShapes()}
                                </Box>
                                {showAllShape ? (
                                    <div onClick={() => setShowAllShape(false)} style={{ fontSize: 11, fontWeight: 'bold', cursor: "pointer", textAlign: "center", paddingTop: "20px" }}>Fewer shapes <ExpandLessIcon /></div>
                                ) : (
                                    <div onClick={() => setShowAllShape(true)} style={{ fontSize: 11, fontWeight: 'bold', cursor: "pointer", textAlign: "center", paddingTop: "20px" }}>More shapes <ExpandMoreIcon /></div>
                                )}
                            </Box>

                            <Box sx={{ width: "45%", paddingLeft: "20px", paddingRight: "20px", borderRight: "1px solid #ececec" }}>

                                {/* ---------- Color ---------- */}
                                <Box sx={{ paddingBottom: "20px", borderBottom: "1px solid #ececec" }}>
                                    <Typography sx={{ paddingBottom: "10px" }}>
                                        Color<sup style={{ color: "red", marginLeft: "4px" }}>*</sup> &nbsp;&nbsp;
                                        <span onClick={() => setColorWhite(true)} style={{ fontSize: 12, fontWeight: 700, color: colorWhite ? 'black' : 'GrayText', cursor: "pointer" }}>WHITE </span>
                                        |
                                        <span onClick={() => setColorWhite(false)} style={{ fontSize: 12, fontWeight: 700, color: !colorWhite ? 'black' : 'GrayText', cursor: "pointer" }}> FANCY</span>
                                    </Typography>
                                    {colorWhite ? (
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(11, 1fr)", gap: "8px 6px" }}>
                                            {colorOptions.map((color, idx) => (
                                                <button
                                                    onClick={() => handleColorSelect(idx)}
                                                    style={{ borderRadius: 4, margin: 2, minWidth: '35px', height: '35px', alignItems: 'center', backgroundColor: color.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                                    <div>
                                                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{color.label}</p>
                                                    </div>
                                                </button>
                                            ))}
                                        </Box>
                                    ) : (
                                        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={"5px"}>
                                            <Box style={{ display: 'flex', flexDirection: 'row', gap: '10px', width: '100%' }}>
                                                <Box style={{ width: '35%', alignSelf: 'flex-end' }}>
                                                    <span style={{ fontSize: 12, fontWeight: "bold" }}>
                                                        INTENSITY
                                                    </span>
                                                    <Select menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="From"
                                                        value={fromIntensity}
                                                        name="From"
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                        options={intensityOption}
                                                        onChange={(selectedOption) => setFromIntensity(selectedOption)}
                                                    />
                                                </Box>
                                                <Box style={{ width: '35%', alignSelf: 'flex-end' }}>
                                                    <Select menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="To"
                                                        value={toIntensity}
                                                        name="To"
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                        options={intensityOption}
                                                        onChange={(selectedOption) => setToIntensity(selectedOption)}
                                                    />
                                                </Box>
                                                <Box style={{ width: '30%' }}>
                                                    <span style={{ fontSize: 12, fontWeight: "bold" }}>
                                                        OVERTONE
                                                    </span>
                                                    <Select menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Overtone"
                                                        value={overtone}
                                                        isSearchable={true}
                                                        name="OVERTONE"
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                        options={overtoneOption}
                                                        onChange={(selectedOption) => setOvertone(selectedOption)}
                                                    />
                                                </Box>
                                            </Box>
                                            <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: '10px' }}>
                                                <Box style={{ width: '52%' }}>
                                                    <span style={{ fontSize: 12, fontWeight: "bold" }}>
                                                        FANCY COLOR 1
                                                    </span>
                                                    <Select menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Fancy Color 1"
                                                        value={fancyColorOne}
                                                        isSearchable={true}
                                                        name="FANCY COLOR 1"
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                        options={fancyColorOption}
                                                        onChange={(selectedOption) => setFancyColorOne(selectedOption)}
                                                    />
                                                </Box>
                                                <Box style={{ width: '50%' }}>
                                                    <span style={{ fontSize: 12, fontWeight: "bold" }}>
                                                        FANCY COLOR 2
                                                    </span>
                                                    <Select menuPlacement="auto"
                                                        blurInputOnSelect={false}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Fancy Color 2"
                                                        value={fancyColorTwo}
                                                        isSearchable={true}
                                                        name="FANCY COLOR 2"
                                                        menuPortalTarget={document.body}
                                                        styles={Constants.Styles}
                                                        options={fancyColorOption}
                                                        onChange={(selectedOption) => setFancyColorTwo(selectedOption)}
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                    )}
                                </Box>

                                <Box sx={{ display: "flex", padding: "20px 0" }}>
                                    {/* ---------- Clarity ---------- */}
                                    <Box sx={{ width: "50%", paddingRight: "20px", borderRight: "1px solid #ececec" }}>
                                        <Typography sx={{ paddingBottom: "10px" }}>Clarity<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px 6px" }}>
                                            {clarityOptions.map((clarity, idx) => (
                                                <button
                                                    onClick={() => handleClaritySelect(clarity, idx)}
                                                    style={{ borderRadius: 4, margin: 2, minWidth: '35px', height: '35px', alignItems: 'center', backgroundColor: clarity.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                                    <div>
                                                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{clarity.label}</p>
                                                    </div>
                                                </button>
                                            ))}
                                        </Box>
                                    </Box>

                                    {/* ---------- Flo ---------- */}
                                    <Box sx={{ width: "50%", paddingLeft: "20px" }}>
                                        <Typography sx={{ paddingBottom: "10px" }}>Flo<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "8px 6px" }}>
                                            {floOptions.map((flo, idx) => (
                                                <button
                                                    onClick={() => handleFloSelect(flo, idx)}
                                                    style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '35px', alignItems: 'center', backgroundColor: flo.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                                    <div>
                                                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{flo.label}</p>
                                                    </div>
                                                </button>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>

                            </Box>

                            <Box sx={{ width: "25%", paddingLeft: "20px", paddingRight: "20px" }}>

                                <Box>
                                    <Typography sx={{ paddingBottom: "10px" }}>Cut, Polish & Symmetry</Typography>
                                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "8px 10px" }}>
                                        <button
                                            onClick={() => handle3EX()}
                                            style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '40px', alignItems: 'center', backgroundColor: threeEX ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                            <div>
                                                <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>3EX</p>
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handle3EXCut()}
                                            style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '40px', alignItems: 'center', backgroundColor: threeEXCut ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                            <div>
                                                <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>3EX Cut</p>
                                            </div>
                                        </button>
                                        <button
                                            onClick={() => handle3VG()}
                                            style={{ borderRadius: 4, margin: 2, minWidth: '40px', height: '40px', alignItems: 'center', backgroundColor: threeVGPlus ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                            <div>
                                                <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>3VG+</p>
                                            </div>
                                        </button>
                                    </Box>
                                </Box>

                                <Box sx={{ paddingBottom: "20px" }}>
                                    {/* ---------- Cut ---------- */}
                                    <Box paddingTop={"10px"}>
                                        <Typography sx={{ paddingBottom: "10px" }}>Cut<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: "8px 6px" }}>
                                            {cutOptions.map((cut, idx) => (
                                                <button
                                                    onClick={() => handleCutSelect(cut, idx)}
                                                    style={{ borderRadius: 4, margin: 2, minWidth: '35px', height: '35px', alignItems: 'center', backgroundColor: cut.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                                    <div>
                                                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{cut.label}</p>
                                                    </div>
                                                </button>
                                            ))}
                                        </Box>
                                    </Box>

                                    {/* ---------- Pol ---------- */}
                                    <Box sx={{ paddingTop: "10px" }}>
                                        <Typography sx={{ paddingBottom: "10px" }}>Pol<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: "8px 6px" }}>
                                            {polOptions.map((pol, idx) => (
                                                <button
                                                    onClick={() => handlePolSelect(pol, idx)}
                                                    style={{ borderRadius: 4, margin: 2, minWidth: '35px', height: '35px', alignItems: 'center', backgroundColor: pol.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                                    <div>
                                                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{pol.label}</p>
                                                    </div>
                                                </button>
                                            ))}
                                        </Box>
                                    </Box>

                                    {/* ------------ Sym ---------- */}
                                    <Box sx={{ paddingTop: "10px" }}>
                                        <Typography sx={{ paddingBottom: "10px" }}>Sym<sup style={{ color: "red", marginLeft: "4px" }}>*</sup></Typography>
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: "8px 6px" }}>
                                            {symOptions.map((sym, idx) => (
                                                <button
                                                    onClick={() => handleSymSelect(sym, idx)}
                                                    style={{ borderRadius: 4, margin: 2, minWidth: '35px', height: '35px', alignItems: 'center', backgroundColor: sym.selected ? "#b8bcc4" : '#fff', border: 1, borderStyle: 'solid', borderColor: '#ececec', color: '#000' }}>
                                                    <div>
                                                        <p style={{ fontSize: 11, fontWeight: 'bold', marginBottom: '0rem' }}>{sym.label}</p>
                                                    </div>
                                                </button>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>

                            </Box>
                        </Box>

                        <Box sx={{ display: "flex", justifyContent: "end", padding: "20px 0" }}>
                            <Box sx={{ display: "flex", alignItems: "center", width: "24%", paddingRight: "15px" }}>
                                <Typography sx={{ width: "40%" }}>No of Stones
                                    <sup style={{ color: "red", marginLeft: "4px" }}>*</sup>
                                </Typography>
                                <TextField
                                    sx={{ width: "50%", margin: 0 }}
                                    margin="normal"
                                    label="No of Stones"
                                    placeholder="Enter No of Stones"
                                    value={noOfStones}
                                    type="number"
                                    inputProps={{ step: "1", min: "1", pattern: "[0-9]*" }}
                                    onChange={(e) => {
                                        if (e.target.value !== '' && !isNaN(e.target.value)) {
                                            setNoOfStones(parseInt(e.target.value, 10));
                                        } else if (e.target.value === '') {
                                            setNoOfStones(e.target.value);
                                        }
                                    }}
                                    onBlur={() => {
                                        if (!noOfStones || isNaN(noOfStones)) {
                                            setNoOfStones(1);
                                        }
                                    }}
                                    disabled={!fromTender}  // need enabled only if it called from tender
                                />
                            </Box>
                            <Button
                                sx={{ mr: "15px" }}
                                variant="contained"
                                color="success"
                                onClick={() => addPlan()}
                                disabled={disableAdd}
                            >
                                Add
                            </Button>
                            <Button
                                sx={{ mr: 1 }}
                                variant="contained"
                                color="info"
                                onClick={() => resetPlan()}
                            >
                                Reset
                            </Button>
                        </Box>

                        {data.length > 0 ? (
                            <Box sx={{
                                borderTop: "1px solid #ececec",
                                paddingTop: "20px",
                                ".MuiTableCell-head": {
                                    backgroundColor: "#808080 !important",
                                    color: "white !important",
                                    fontWeight: "600",
                                    padding: "8px 4px",
                                    textAlign: "center"
                                },
                                ".MuiTableCell-root": {
                                    padding: "8px 0",
                                    textAlign: "center"
                                }
                            }}>
                                <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>SR NO</TableCell>
                                                {tenderstoneid ? (
                                                    <>
                                                        <TableCell>TENDER STONE ID</TableCell>
                                                    </>
                                                ) : (
                                                    <>
                                                        <TableCell>KAPAN ID</TableCell>
                                                        <TableCell>PACKET ID</TableCell>
                                                    </>
                                                )}
                                                <TableCell>PLAN</TableCell>
                                                <TableCell>SIZE</TableCell>
                                                <TableCell align="left">SHAPE</TableCell>
                                                <TableCell>COL. TYPE</TableCell>
                                                <TableCell>COLOR</TableCell>
                                                <TableCell>F. COLOR 1</TableCell>
                                                <TableCell>F. COLOR 2</TableCell>
                                                <TableCell>FROM INTENS</TableCell>
                                                <TableCell>TO INTENS</TableCell>
                                                <TableCell>OVERTONE</TableCell>
                                                <TableCell>CLARITY</TableCell>
                                                <TableCell>CUT</TableCell>
                                                <TableCell>POL</TableCell>
                                                <TableCell>SYM</TableCell>
                                                <TableCell>FLO</TableCell>
                                                <TableCell align="left">STONETYPE</TableCell>
                                                <TableCell>LAB</TableCell>
                                                <TableCell>CERTIFIED</TableCell>
                                                <TableCell>NO. OF STONES</TableCell>
                                                <TableCell>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.map((row, index) => (
                                                <TableRow
                                                    key={index + 1}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">{index + 1}</TableCell>
                                                    {tenderstoneid ? (
                                                        <>
                                                            <TableCell>{row.tenderstoneid}</TableCell>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <TableCell>{row.kapanid}</TableCell>
                                                            <TableCell>{row.packetid}</TableCell>
                                                        </>
                                                    )}
                                                    <TableCell>{row.planid.label}</TableCell>
                                                    <TableCell>{row.size}</TableCell>
                                                    <TableCell>{row.shape.label}</TableCell>
                                                    <TableCell>{row.colortype}</TableCell>
                                                    <TableCell>{row.color ? row.color.label : "-"}</TableCell>
                                                    <TableCell>{row.fancycolor1 ? row.fancycolor1.label : "-"}</TableCell>
                                                    <TableCell>{row.fancycolor2 ? row.fancycolor2.label : "-"}</TableCell>
                                                    <TableCell>{row.fromintensity ? row.fromintensity.label : "-"}</TableCell>
                                                    <TableCell>{row.tointensity ? row.tointensity.label : "-"}</TableCell>
                                                    <TableCell>{row.overtone ? row.overtone.label : "-"}</TableCell>
                                                    <TableCell>{row.clarity.label}</TableCell>
                                                    <TableCell>{row.cut.label}</TableCell>
                                                    <TableCell>{row.pol.label}</TableCell>
                                                    <TableCell>{row.sym.label}</TableCell>
                                                    <TableCell>{row.flo.label}</TableCell>
                                                    <TableCell>{row.stonetype.value}</TableCell>
                                                    <TableCell>{row.lab.label}</TableCell>
                                                    <TableCell>{row.iscertified ? <CheckIcon /> : <CloseIcon />}</TableCell>
                                                    <TableCell>{row.noofstones}</TableCell>
                                                    <TableCell>
                                                        <Tooltip>
                                                            <DeleteForeverIcon color={"error"} onClick={(e) => deletePlan(index)} />
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        ) : null}

                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Box sx={{
                        "& .Mui-disabled": {
                            backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                            color: "rgba(0, 0, 0, 0.26) !important"
                        }
                    }}>
                        <LoadingButton
                            sx={{ mr: 1 }}
                            variant="contained"
                            color="info"
                            onClick={handleSubmit}
                            loading={loader}
                            loadingPosition="start"
                            startIcon={<AssignmentTurnedInIcon />}
                            type="Submit"
                            disabled={data.length === 0}
                        >
                            Submit
                        </LoadingButton>
                    </Box>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div >
    );
};

export default AddPricePlanModal;